function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-redo-alt",
  "data-name": "Icon awesome-redo-alt",
  d: "M6.551.562A5.98,5.98,0,0,0,2.418,2.224L1.554,1.36a.581.581,0,0,0-.991.411V5.014a.581.581,0,0,0,.581.581H4.387A.581.581,0,0,0,4.8,4.6l-1.01-1.01a4.064,4.064,0,1,1,.1,6.028.29.29,0,0,0-.4.013l-.96.96a.291.291,0,0,0,.012.422A6,6,0,1,0,6.551.562Z",
  transform: "translate(-0.563 -0.563)",
  fill: "#fff"
});

var SvgIconawesomeRedoAlt = function SvgIconawesomeRedoAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconawesomeRedoAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon awesome-redo-alt.057b9ea1.svg";
export { ForwardRef as ReactComponent };